import { ENDPOINT_BASE } from '@/config/endpoints'

/**
 * Project status membership endpoints (attach/detach a workspace status to/from
 * a specific project). Routed under the workspace + project path:
 *   /api/v1.0/e/{workspaceSlug}/projects/{projectId}/statuses/{statusId}
 */
export const ENDPOINT_PROJECT_STATUSES = `${ENDPOINT_BASE}/e`
